import { useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Color from "../../../assets/colors";
import {
  bookmarkCompanyAffiliate,
  unBookmarkCompanyAffiliate,
  updateSelectedCompany,
} from "../../../redux/actions/company_action";
import {
  updateShowSignInModalStatus,
  updateSignUpOrigin,
} from "../../../redux/actions/navbar_action";
import { checkAuthentication } from "../../../redux/actions/user_action";
import {
  BookmarkFilledIconStyled,
  BookmarkIconStyled,
  CircularProgressStyled,
  CompanyLogo,
  FlexContainer,
  IndustryIconStyled,
  JobIconStyled,
  LinkWrapper,
  SectionContainer,
  TextStyled,
} from "../styles";
import { CardStyled, CompanyBanner } from "./styles";

function CompanyAffiliates(companyAffiliates) {
  const isTablet = useMediaQuery("(min-width: 640px)");

  return (
    <SectionContainer aria-label="company affiliates section">
      <FlexContainer flexDirection={"column"} gap={"1.5rem"}>
        <TextStyled
          variant="h2"
          fontSize="1.25rem"
          fontWeight={700}
          textTransform="capitalize"
          aria-label="company affiliates section title"
          color={"#000"}
        >
          Our Affiliates
        </TextStyled>
        {Array.isArray(companyAffiliates?.companyAffiliates) ? (
          companyAffiliates?.companyAffiliates?.map((affiliates, index) => {
            return (
              <FlexContainer
                key={index}
                flexDirection={isTablet ? "row" : "column"}
                gap={isTablet ? "1rem" : "1rem"}
                alignItems={isTablet ? "flex-start" : "center"}
              >
                <CompanyLogo
                  src={affiliates?.affiliatedCompany?.logo}
                  width={145}
                  height={145}
                  alt={affiliates?.affiliatedCompany?.name + " company logo"}
                  aria-label="company-logo-image"
                />
                <CompanyCard company={affiliates?.affiliatedCompany} />
              </FlexContainer>
            );
          })
        ) : (
          <FlexContainer
            flexDirection={isTablet ? "row" : "column"}
            gap={isTablet ? "1rem" : "1rem"}
            alignItems={isTablet ? "flex-start" : "center"}
          >
            <CompanyLogo
              src={companyAffiliates?.companyAffiliates?.company?.logo}
              width={145}
              height={145}
              alt={
                companyAffiliates?.companyAffiliates?.company?.name +
                " company logo"
              }
              aria-label="company-logo-image"
            />
            <CompanyCard
              company={companyAffiliates?.companyAffiliates?.company}
            />
          </FlexContainer>
        )}
      </FlexContainer>
    </SectionContainer>
  );
}

function CompanyCard(props) {
  const { company } = props || {};

  const dispatch = useDispatch();

  const bookmarking = useSelector(
    (state) => state.companies.bookmarkingCompanyAffiliates
  );
  const unbookmarking = useSelector(
    (state) => state.companies.unbookmarkCompanyAffiliates
  );

  async function handleBookmarkCompany(e, companyId) {
    e.preventDefault();
    e.stopPropagation();

    const loggedIn = checkAuthentication();

    if (!loggedIn) {
      return dispatch(updateSelectedCompany(company)).then(() => {
        dispatch(updateSignUpOrigin("save_company")).then(() => {
          dispatch(updateShowSignInModalStatus(true));
        });
      });
    }

    if (!company?.bookmark) {
      await dispatch(bookmarkCompanyAffiliate({ companyId: companyId }));
    } else if (company?.bookmark) {
      await dispatch(unBookmarkCompanyAffiliate({ companyId: companyId }));
    }
  }
  return (
    <LinkWrapper
      href={"/companies/" + company?.slug}
      rel="noopener noreferrer"
      target="_blank"
    >
      <CardStyled>
        <CompanyBanner
          style={{
            backgroundImage: `url(${company?.coverImageThumb})`,
          }}
        >
          <FlexContainer
            flexDirection={"column"}
            alignItems="flex-end"
            justifyContent="space-between"
            height="100%"
            padding="0.75rem"
          >
            {bookmarking || unbookmarking ? (
              <CircularProgressStyled />
            ) : company?.bookmark ? (
              <BookmarkFilledIconStyled
                onClick={(e) => handleBookmarkCompany(e, company?.id)}
                width="2rem"
                height="2rem"
                stroke={Color.black}
              />
            ) : (
              <BookmarkIconStyled
                onClick={(e) => handleBookmarkCompany(e, company?.id)}
                width="2rem"
                height="2rem"
                stroke={Color.black}
              />
            )}

            <CompanyLogo
              src={company?.logo}
              loading="lazy"
              width={80}
              height={80}
              alt={company?.name + " company logo"}
              aria-label="company-logo-image"
              style={{ border: `1px solid ${Color.black}` }}
            />
          </FlexContainer>
        </CompanyBanner>
        <FlexContainer
          flexDirection={"column"}
          padding="0.75rem 1rem 1rem 1rem"
          gap="0.5rem"
        >
          <FlexContainer gap={"1rem"}>
            <CompanyLogo
              src={company?.logo}
              loading="lazy"
              width={24}
              height={24}
              alt={company?.name + " company logo"}
              aria-label="company-logo-image"
              style={{
                border: `0.5px solid ${Color.black}`,
                borderRadius: "0.25rem",
              }}
            />

            <TextStyled
              variant="h3"
              fontSize="1.125rem"
              fontWeight={700}
              fontFamily={"Karla"}
              letterSpacing={"0.27px"}
            >
              {company?.name}
            </TextStyled>
          </FlexContainer>
          <FlexContainer flexDirection={"column"} gap="0.5rem">
            <FlexContainer
              alignItems="center"
              gap={"0.5rem"}
              textTransform="capitalize"
            >
              <IndustryIconStyled />

              <TextStyled
                variant="h4"
                fontSize="0.875rem"
                fontWeight={400}
                fontFamily={"Karla"}
                letterSpacing={"0.15px"}
              >
                {company?.industry}
              </TextStyled>
            </FlexContainer>

            <FlexContainer alignItems="center" gap={"0.5rem"}>
              <JobIconStyled />
              <TextStyled
                variant="h4"
                fontSize="0.875rem"
                fontWeight={400}
                fontFamily={"Karla"}
                letterSpacing={"0.15px"}
              >
                {company?.jobCount + " jobs"}
              </TextStyled>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
      </CardStyled>
    </LinkWrapper>
  );
}

export default CompanyAffiliates;
